import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import { PaginatedResults } from '../../models/paginated_results_model';
import { PaginationOptions } from '../../models/pagination_options';
import { LoadPort } from '../../models/load-port';

@Injectable({
  providedIn: 'root',
})
export class LoadPortService {
  currentDomain = environment.currentApiHostname
  apiUrl = `https://${this.currentDomain}/api/general`;


  constructor(private http: HttpClient) {}

  get(paginationOptions: PaginationOptions) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<PaginatedResults>(
      this.apiUrl +
        `/load-ports?${PaginationOptions.getPaginationQueryParameters(
          paginationOptions
        )}`,
      options
    );
  }



  all() {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<Array<LoadPort>>(
      this.apiUrl +  `/load-ports/index/all`,
      options
    );
  }

  export(type: string, paginationOptions: PaginationOptions) {
    const options = {
      responseType: 'blob' as 'blob',
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };


    return this.http.get(
      this.apiUrl +
        `/exports/load-ports/export/${type}?${PaginationOptions.getPaginationQueryParameters(
          paginationOptions
        )}`,
      options
    );
  }


  show(uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',

        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.get<LoadPort>(
      this.apiUrl +  `/load-ports/${uuid}`,
      options
    );
  }

  store(category: any) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<LoadPort>(
      this.apiUrl +  `/load-ports`,
      category,
      options
    );
  }

  update(category: any, uuid: string) {
    const options = {
      headers: new HttpHeaders({
        Accept: 'application/json',
        Authorization: 'Bearer ' + localStorage.getItem('access_token'),
      }),
    };

    return this.http.post<LoadPort>(
      this.apiUrl +  `/load-ports/update/${uuid}`,
      category,
      options
    );
  }
}
